module.exports = __webpack_public_path__ + "static/img/22.c4ead34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/digitalize/22.png
// module id = 2MGp
// module chunks = 2